<template>
  <div class="ofs-orphan">
    <Bars3Icon aria-hidden="true" class="ofs-orphan__handle handle" />
    <span class="ofs-orphan__name handle">{{ name }}</span>
    <MoveTo v-if="data" :data @select="handleSelect" />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { UNKNOWN_VALUE } from '@/const'
import { DropdownListData } from '@types'

import { Bars3Icon } from '@heroicons/vue/24/outline'
import MoveTo from './components/MoveTo.vue'

type Props = {
  element: string
  data?: DropdownListData[]
}

type Emits = {
  'select': [value: string]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
  
const nameFormatter = inject<(name: string) => string>('nameFormatter')

const name = computed(() => nameFormatter?.(props.element) || UNKNOWN_VALUE)

const handleSelect = (value: string) => {
  emit('select', value)
}

</script>

<style>
.ofs-area__unorganized .ofs-area__tree-item-name,
.ofs-orphan {
  @apply flex items-center justify-between shrink-0;
  @apply py-1.5 px-2.5 gap-2;
  @apply border border-common-border;
  @apply rounded-md;
  @apply bg-body;
  @apply text-sm;
  @apply truncate;

  &__name {
    @apply flex-auto;
  }

  &__handle {
    @apply size-4;
  }

  .handle {
    @apply cursor-move;
  }
}

.ofs-area__unorganized .ofs-area__tree-item-name {
  @apply opacity-50;
}
</style>
